import cn from 'classnames';
import {FC} from 'react';
import styles from './Progress.module.css';

type Props = {
	currentStep: number;
	totalSteps: number;
	align?: 'start' | 'center';
	className?: string;
};

export const Progress: FC<Props> = ({currentStep, totalSteps, align = 'center', className}) => (
	<div
		className={cn(styles.root, align === 'start' && styles.alignStart, className)}
		role="progressbar"
		aria-valuenow={currentStep + 1}
		aria-valuemin={1}
		aria-valuemax={totalSteps}
	>
		{Array.from({length: totalSteps}, (_, index) => (
			<span
				key={index}
				className={cn(
					styles.segment,
					index < currentStep && styles.segmentCompleted,
					index === currentStep && styles.segmentCurrent,
				)}
			/>
		))}
	</div>
);
